export default __webpack_public_path__ + "static/media/men-women-icon.b7ac2473.svg";